import {
  Dialog,
  Stack,
  Box,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ContainedButton } from "@/common";

interface StandardConfirmationModalProps extends StandardModalProps {
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl";
  noPadding?: boolean;
  onConfirm: () => void;
  icon: React.ReactNode;
  title: string;
  description: string;
  confirmButtonColor?: "error" | "success";
  confirmButtonTitle?: string;
  confirmButtonLoader?: boolean;
}

const StandardConfirmationModal = ({
  open,
  onClose,
  noPadding,
  maxWidth,
  onConfirm,
  icon,
  title,
  description,
  confirmButtonColor = "error",
  confirmButtonTitle = "Confirm",
  confirmButtonLoader,
}: StandardConfirmationModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      sx={{
        backgroundColor: "rgba(30, 30, 30, 0.34)",
        ".MuiDialog-paper": {
          padding: noPadding ? "0rem" : "1.7rem",
          "::-webkit-scrollbar": { width: "0" },
        },
        div: {
          borderRadius: "16px",
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box>{icon}</Box>
        <IconButton onClick={onClose}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Box>
      <Box my={2}>
        <Typography fontSize={20} noWrap fontWeight={500}>
          {title}
        </Typography>
        <Typography fontSize={15} color={"#8C8E9C"} fontWeight={400}>
          {description}
        </Typography>
      </Box>
      <Stack spacing={2} direction={"row"} pt={3}>
        <ContainedButton
          title="Close"
          size="large"
          onClick={onClose}
          sx={{
            border: "1px solid #E6E6E9",
            flex: "1",
            color: "black",
            boxShadow:
              "0px 1px 3px 0px rgba(16, 24, 32, 0.05), 0px 23px 44px 0px rgba(16, 24, 32, 0.05)",
          }}
          variant="white-contained"
        />
        <ContainedButton
          size="large"
          title={confirmButtonTitle}
          color={confirmButtonColor}
          disabled={confirmButtonLoader}
          {...(confirmButtonLoader && {
            startIcon: <CircularProgress sx={{ color: "white" }} size={20} />,
          })}
          onClick={onConfirm}
          sx={{ flex: 1, color: "#FFFFFF" }}
        />
      </Stack>
    </Dialog>
  );
};

export default StandardConfirmationModal;
